import React, { useState } from 'react'
import axios from 'axios'
import download from 'downloadjs'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload'
import { useConfig } from '@peracto/peracto-config'

const Export = ({ contentId }) => {
    const config = useConfig()
    const [loading, setLoading] = useState(false)

    const handleExport = async () => {
        setLoading(true)

        try {
            const { data } = await axios.get(
                `${config.get('api')}/contents/${contentId}/export.json`,
                {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                }
            )

            download(
                JSON.stringify(data, null, 4),
                `content-${data.content?.slug || contentId}.json`,
                'application/json'
            )

            data.warnings?.forEach(warning =>
                toast.warning(
                    `${warning.type} "${warning.name}" (${warning.reason}) was not exported`
                )
            )
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'Failed to export content')
        } finally {
            setLoading(false)
        }
    }

    return (
        <button
            title="Export"
            className="btn"
            onClick={handleExport}
            disabled={loading}
            data-testid="content-export"
        >
            <FontAwesomeIcon icon={faDownload} />
        </button>
    )
}

export default Export
